export default "__VITE_ASSET__D09j3L8f__"